<template>
  <screen
    v-show="show"
    :screen-name="$t('tutorial.title')"
    :screen-info="$t('tutorial.raise_arm')"
    @skip="$emit('skip')"
  >
    <circle-window>
      <hand-raise />
    </circle-window>
  </screen>
</template>

<script>
import autoNext from '../../mixins/auto-next';

import Screen from '../common/Screen.vue';
import CircleWindow from './CircleWindow.vue';
import HandRaise from './HandRaise.vue';

export default {
  name: 'HandRaiseReady',
  components: {
    Screen,
    CircleWindow,
    HandRaise,
  },
  mixins: [autoNext],
  data: () => ({
    duration: 3,
  }),
};
</script>
